// src/App.jsx

import './App.css';
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import CodeInput from './components/CodeInput';
import RegistrationForm from './components/RegistrationForm';
import Dashboard from './components/StudentDashboard';
import AdminDashboard from './components/AdminDashboard';
import Layout from './components/Layout';
import InterviewQuestions from './components/InterviewQuestions';

// YENİ IMPORT
// Mevcut Import
import SuraDashboard from './components/SuraDashboard';

export default function App() {
  return (
    <Router>
      <Routes>
        
        {/* ========================================================= */}
        {/* YENİ ROTA: Namaz Vakitleri Landing Page (Layoutsuz) */}
        {/* ========================================================= */}
        {/* <Route path='/prayer-times' element={<PrayerTimeLanding />} /> */}
        
        {/* Eğitim Dashboard'u (Sure Ezberleme) */}
        <Route path='/sura-dashboard/:studentId' element={<SuraDashboard />} />

        {/* ========================================================= */}
        {/* KARİYER KOÇLUĞU SAYFALARI (Layout'u kullanan rotalar) */}
        {/* ========================================================= */}
        <Route element={<Layout />}>
          {/* Ana Sayfa: Kariyer Koçluğu Landing Page (InterviewQuestions) */}
          <Route path='/' element={<InterviewQuestions />} /> 
          
          <Route path='/login' element={<CodeInput />} />

          {/* Redirect /register to /register/demo */}
          <Route path='/register' element={<Navigate to='/register/demo' />} />
          <Route path='/register/:code' element={<RegistrationForm />} />

          {/* Kariyer Koçluğu Dashboard'u */}
          <Route path='/dashboard/:studentId' element={<Dashboard />} />
        </Route>

        {/* Admin Dashboard without Layout */}
        <Route path='/admin' element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}